import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

export interface JoinActivityCallResult {
  call: {
    id: string;
    room: string;
    state: string;
  };
  token: string | null;
  url: string;
}

/**
 * Start or join the group call for an Activity (Issue). No ringing — lazily
 * creates one ACTIVE call per Issue (room `activity-<issueId>`) or joins the
 * existing one, and resolves with the caller's LiveKit token + server url.
 */
export const useJoinActivityCall = () => {
  const fetcherFn = useFetcher<
    { call: { joinActivityCall: JoinActivityCallResult } },
    { input: { issueId: string } }
  >(JOIN_ACTIVITY_CALL);

  return useMutation({
    mutationFn: async (issueId: string): Promise<JoinActivityCallResult> => {
      const data = await fetcherFn({ input: { issueId } });
      return data.call.joinActivityCall;
    },
  });
};

const JOIN_ACTIVITY_CALL = `
  mutation JOIN_ACTIVITY_CALL($input: JoinActivityCallInput!) {
    call {
      joinActivityCall(input: $input) {
        call {
          id
          room
          state
        }
        token
        url
      }
    }
  }
`;
